import { connect } from 'react-redux';
import Component from './Component';

import onClickAddProcurementItem from '../../Handlers/onClickAddProcurementItem';
import onClickDeleteProcurementItem from '../../Handlers/onClickDeleteProcurementItem';
import onClickShowCatalogPicker from '../../Handlers/onClickShowCatalogPicker';
import onChangeProcurementItemField from '../../Handlers/onChangeProcurementItemField';
import onBlurProcurementItemField from '../../Handlers/onBlurProcurementItemField';
import onClickSaveProcurementItems from '../../Handlers/onClickSaveProcurementItems';

const mapStateToProps = (state) => ({
  procurementItems: state.screens.OrderView.procurementItems,
  suppliers: state.core.suppliers,
  editable: state.screens.OrderView.editable,
})

const actionCreators = {
  onClickAddProcurementItem,
  onClickDeleteProcurementItem,
  onClickShowCatalogPicker,
  onChangeProcurementItemField,
  onBlurProcurementItemField,
  onClickSaveProcurementItems,
};

export default connect(mapStateToProps, actionCreators)(Component);
